import { AsyncStorageSecurityContextHolder, type  SecurityContext } from './security-context.ts';
import { ServerWebExchangeDecorator } from '../exchange.ts';
import type { ServerWebExchange } from '../../../types/web/server';
import type { Principal } from '../../../types/auth';
import type { AsyncLocalStorage } from 'node:async_hooks';
import type { WebFilterChain } from '../../web/server/types.ts';


export class SecurityContextServerWebExchange extends ServerWebExchangeDecorator {
    readonly #context: () => Promise<SecurityContext | undefined>;
    constructor(exchange: ServerWebExchange, context: () => Promise<SecurityContext | undefined>) {
        super(exchange);
        this.#context = context;
    }

    async principal<T extends Principal>(): Promise<T | undefined> {
        const context = await this.#context();
        return context?.authentication as (T | undefined);
    }
}

export const exchangeFilter = (opts: {storage: AsyncLocalStorage<{ securityContext?: Promise<SecurityContext> }>}) => {
    const storage = opts.storage;
    return {
        filter: async (exchange: ServerWebExchange, chain: WebFilterChain) => {
            await chain.filter(new SecurityContextServerWebExchange(exchange, async () => await AsyncStorageSecurityContextHolder.getContext(storage)));
        }
    };
}
